import { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Avatar,
  Chip,
  Stack,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import PlaceRoundedIcon from '@mui/icons-material/PlaceRounded';
import FlagRoundedIcon from '@mui/icons-material/FlagRounded';
import MonetizationOnRoundedIcon from '@mui/icons-material/MonetizationOnRounded';
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import UploadFileRoundedIcon from '@mui/icons-material/UploadFileRounded';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import PropaneTankIcon from '@mui/icons-material/PropaneTank';
import ShoppingCartRoundedIcon from '@mui/icons-material/ShoppingCartRounded'; // Importado para Compras

import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthProvider';

// Estructura agrupada por categorías
const menuGroups = [
  {
    title: 'Dashboards & KPIs',
    icon: <SpaceDashboardIcon fontSize="small" />,
    items: [
      { label: 'Tanks Dashboard', route: '/diesel/tanks', icon: <PropaneTankIcon fontSize="small" /> },
      { label: 'MPG - PIVOT', route: '/diesel/kpi/dashboard', icon: <SpaceDashboardIcon fontSize="small" /> },
      { label: 'Master Dashboard', route: '/diesel/fuel_up/v2/master_dashboard', icon: <DashboardRoundedIcon fontSize="small" /> },
      { label: 'Metas', route: '/diesel/metas', icon: <FlagRoundedIcon fontSize="small" /> },
    ],
  },
  {
    title: 'Cargas de Combustible',
    icon: <LocalGasStationIcon fontSize="small" />,
    items: [
      { label: 'Cargas de Arguindegui', route: '/diesel/CargasArguin', icon: <LocalGasStationIcon fontSize="small" /> },
      { label: 'Cargas de Colombia', route: '/diesel/fuel_up/v2/', icon: <LocalGasStationIcon fontSize="small" /> },
      { label: 'Cargas de Fuel America', route: '/diesel/CargasFuelAmerica', icon: <LocalGasStationIcon fontSize="small" /> },
      { label: 'Cargas de GasoMax', route: '/diesel/CargasGasoMax', icon: <LocalGasStationIcon fontSize="small" /> },
      { label: 'Cargas de Love\'s', route: '/diesel/CargasLoves', icon: <LocalGasStationIcon fontSize="small" /> },
      { label: 'Cargas de Monterrey', route: '/diesel/fuel_up/v2/2', icon: <LocalGasStationIcon fontSize="small" /> },
      { label: 'Cargas de OXXO', route: '/diesel/CargasOxxo', icon: <LocalGasStationIcon fontSize="small" /> },
      { label: 'Cargas DEF', route: '/diesel/cargas/def', icon: <LocalGasStationIcon fontSize="small" /> },
    ],
  },
  {
    title: 'Compras',
    icon: <ShoppingCartRoundedIcon fontSize="small" />,
    items: [
      { label: 'Compras DEF', route: '/diesel/compras/def', icon: <ShoppingCartRoundedIcon fontSize="small" /> },
      { label: 'Compras Diesel', route: '/diesel/compras', icon: <ShoppingCartRoundedIcon fontSize="small" /> },
    ],
  },
  {
    title: 'Love\'s',
    icon: <PlaceRoundedIcon fontSize="small" />,
    items: [
      { label: 'Love\'s Stops', route: '/diesel/stops', icon: <PlaceRoundedIcon fontSize="small" /> },
      { label: 'Reporte Love\'s', route: '/diesel/reporteLoves', icon: <ReceiptLongRoundedIcon fontSize="small" /> },
    ],
  },
  {
    title: 'Omnitracs',
    icon: <AssessmentRoundedIcon fontSize="small" />,
    items: [
      { label: 'Ver Omnitracs', route: '/diesel/omni/ver', icon: <AssessmentRoundedIcon fontSize="small" /> },
      // { label: 'Subir Info Omnitracs', route: '/diesel/omni/subir', icon: <UploadFileRoundedIcon fontSize="small" /> },
    ],
  },
  {
    title: 'Samsara',
    icon: <AssessmentRoundedIcon fontSize="small" />,
    items: [
        {
            label: 'Rendimiento diario',
            route: '/diesel/samsara/rendimiento',
            icon: <AssessmentRoundedIcon fontSize="small" />
        },
        {
            label: 'Rendimiento por resets',
            route: '/diesel/samsara/resets',
            icon: <AssessmentRoundedIcon fontSize="small" />
        }
    ],
  },
  {
    title: 'Precios',
    icon: <MonetizationOnRoundedIcon fontSize="small" />,
    items: [
      { label: 'EBT Daily Fuel Price', route: '/diesel/daily-fuel-price', icon: <MonetizationOnRoundedIcon fontSize="small" /> },
      { label: 'Precios Base', route: '/diesel/precios', icon: <MonetizationOnRoundedIcon fontSize="small" /> },
    ],
  },
];

const dieselButtonSx = (active) => ({
  borderRadius: '12px',
  px: 2,
  py: 1,
  textTransform: 'none',
  fontWeight: 700,
  whiteSpace: 'nowrap',
  color: active ? '#0f172a' : '#334155',
  background: active ? '#ffffff' : 'rgba(255,255,255,0.72)',
  border: active ? '1px solid rgba(59,130,246,0.3)' : '1px solid rgba(148,163,184,0.18)',
  boxShadow: active ? '0 6px 16px rgba(37,99,235,.12)' : 'none',
  '&:hover': { background: '#ffffff' },
});

const GroupDropdown = ({ group, navigate, currentPath }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const isGroupActive = group.items.some((item) => currentPath.startsWith(item.route));

  return (
    <>
      <Button
        startIcon={group.icon}
        endIcon={<KeyboardArrowDownIcon />}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={dieselButtonSx(isGroupActive)}
      >
        {group.title}
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        PaperProps={{
          elevation: 3,
          sx: { borderRadius: 3, minWidth: 200, mt: 1 },
        }}
      >
        {group.items.map((item) => {
          const isSelected = currentPath.startsWith(item.route);
          return (
            <MenuItem
              key={item.route}
              selected={isSelected}
              onClick={() => {
                setAnchorEl(null);
                navigate(item.route);
              }}
              sx={{ py: 1, px: 2, borderRadius: 1, mx: 0.5 }}
            >
              <ListItemIcon sx={{ color: isSelected ? '#2563eb' : '#64748b', minWidth: 32 }}>
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={item.label}
                primaryTypographyProps={{
                  fontSize: '0.875rem',
                  fontWeight: isSelected ? 700 : 500,
                  color: isSelected ? '#2563eb' : '#334155',
                }}
              />
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logOut, userData } = useAuth();

  const displayName = userData?.nombre || userData?.username || 'Usuario';
  const initial = displayName?.charAt(0)?.toUpperCase() || 'U';

  return (
    <AppBar position="sticky" elevation={0} sx={{ background: 'rgba(255,255,255,0.88)', backdropFilter: 'blur(14px)', borderBottom: '1px solid rgba(148,163,184,0.18)', color: '#0f172a' }}>
      <Toolbar sx={{ minHeight: 70, px: { xs: 2, md: 4 }, display: 'flex', justifyContent: 'space-between', gap: 2 }}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Box sx={{ width: 44, height: 44, borderRadius: 2.5, display: 'grid', placeItems: 'center', background: 'linear-gradient(135deg, #2563eb 0%, #06b6d4 100%)', color: '#fff' }}>
            <LocalGasStationIcon />
          </Box>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 800, lineHeight: 1.1, fontSize: '1.1rem' }}>
              Diésel
            </Typography>
            <Typography variant="caption" sx={{ color: '#64748b' }}>
              Panel operativo · EBT
            </Typography>
          </Box>
        </Stack>

        <Stack direction="row" spacing={1} alignItems="center">
          <Chip
            avatar={<Avatar sx={{ bgcolor: '#dbeafe', color: '#1d4ed8', fontWeight: 800 }}>{initial}</Avatar>}
            label={displayName}
            variant="outlined"
            sx={{ borderColor: 'rgba(59,130,246,0.18)', backgroundColor: 'rgba(239,246,255,.86)', '& .MuiChip-label': { fontWeight: 700 } }}
          />
          <Button
            startIcon={<LogoutRoundedIcon />}
            onClick={() => { logOut(); navigate('/'); }}
            sx={{ borderRadius: 999, px: 2, py: 0.8, fontWeight: 700, textTransform: 'none', color: '#ef4444', border: '1px solid rgba(239,68,68,.14)', backgroundColor: 'rgba(254,242,242,.9)' }}
          >
            Cerrar sesión
          </Button>
        </Stack>
      </Toolbar>

      {/* Sub-bar con los grupos desplegables */}
      <Box sx={{ px: { xs: 2, md: 4 }, py: 1, borderTop: '1px solid rgba(148,163,184,0.10)', background: 'rgba(248,250,252,.8)' }}>
        <Stack direction="row" spacing={1.5} sx={{ overflowX: 'auto' }}>
          {menuGroups.map((group) => (
            <GroupDropdown
              key={group.title}
              group={group}
              navigate={navigate}
              currentPath={location.pathname}
            />
          ))}
        </Stack>
      </Box>
    </AppBar>
  );
};

export default Navbar;